module.exports = __webpack_public_path__ + "img/kuang_up.6e6276d7.png";